if (!customElements.get('tis-gift-card-visual')) {
  class TisGiftCardVisual extends HTMLElement {
    connectedCallback() {
      this.handleChange = this.handleChange.bind(this);
      this.addEventListener('change', this.handleChange);

      const section = this.closest('section') || document;
      section.addEventListener('change', this.handleChange);
      this.section = section;

      requestAnimationFrame(() => this.syncFromPicker());
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.handleChange);
      if (this.section) this.section.removeEventListener('change', this.handleChange);
    }

    handleChange(event) {
      const select = event.target.closest('select[name^="options["]');
      if (!select || !this.isThemeSelect(select)) return;
      this.showTheme(select.value);
    }

    syncFromPicker() {
      const scope = this.closest('section') || document;
      const themeSelect = [...scope.querySelectorAll('select[name^="options["]')].find((select) =>
        this.isThemeSelect(select)
      );

      this.showTheme(themeSelect ? themeSelect.value : this.dataset.selectedTheme);
    }

    isThemeSelect(select) {
      const name = (select.getAttribute('name') || '').toLowerCase();
      return name.includes('theme') || name.includes('design');
    }

    normalizeTheme(value) {
      const theme = String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-');

      if (theme.includes('holiday')) return 'happy-holidays';
      if (theme.includes('birthday')) return 'happy-birthday';
      if (theme.includes('congrat')) return 'congrats';
      if (theme.includes('thank')) return 'thank-you';
      return 'standard';
    }

    showTheme(value) {
      const selectedTheme = this.normalizeTheme(value);
      const images = [...this.querySelectorAll('[data-gift-card-theme]')];
      const selectedImage = images.find((image) => image.dataset.giftCardTheme === selectedTheme) || images[0];

      images.forEach((image) => {
        image.hidden = image !== selectedImage;
      });

      this.dataset.selectedTheme = selectedImage?.dataset.giftCardTheme || 'standard';
    }
  }

  customElements.define('tis-gift-card-visual', TisGiftCardVisual);
}
